import React, { useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { Grid } from "@mui/material";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { FREQUENCIES } from "../forms-allocation/constants";
import { Dropdown } from "primereact/dropdown";
import { controlMeasureTypeAdd, controlMeasureTypeUpdate } from "../../service/controlMeasureService";
import { QuillEditor } from "../../components/QuillEditor";
export default function ControlMeasureTypeAdd(modalProps: any) {
  const details = modalProps?.details;

  const [name, setName] = useState(details?.name || "");
  const [description, setDescription] = useState(details?.description || "");


  async function addIndustry() {
    const updateDetails = {
      name,
      description
    };
    if (modalProps.id) {
      controlMeasureTypeUpdate(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Control Measure Type Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      controlMeasureTypeAdd(updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Control Measure Type Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>
              Name<div style={{ color: "red" }}>*</div>
            </FormLabel>
            <FormControl
              sx={{
                display: { sm: "flex-column", md: "flex-row" },
                gap: 2,
              }}
            >
              <InputText
                value={name}
                onChange={(e) => setName(e.target.value)}
                type="text"
                className="p-inputtext-sm PrimeSmallInput"
              />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <QuillEditor
            label="Description"
            hidePlaceholder={true}
            content={description}
            setContent={setDescription}
            toast={modalProps.toast}
          />
        </Grid>
      </Grid>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
